import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { storageKeys } from '@/config/env';

interface SidebarStore {
  /** Desktop: collapsed to a 60px icon rail. Persisted. */
  collapsed: boolean;
  /** Mobile: the drawer is open. Deliberately NOT persisted. */
  mobileOpen: boolean;
  /**
   * Keys of expanded groups. Deliberately NOT persisted: a sidebar of six
   * groups restored wide open is most of a screen of links before you have
   * asked for any of them. Each load starts closed, and the group holding the
   * current page opens itself.
   */
  openGroups: string[];

  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
  setMobileOpen: (open: boolean) => void;
  toggleGroup: (key: string) => void;
  openGroup: (key: string) => void;
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set, get) => ({
      collapsed: false,
      mobileOpen: false,
      openGroups: [],

      toggleCollapsed: () => set({ collapsed: !get().collapsed }),
      setCollapsed: (collapsed) => set({ collapsed }),
      setMobileOpen: (mobileOpen) => set({ mobileOpen }),

      toggleGroup: (key) =>
        set({
          openGroups: get().openGroups.includes(key)
            ? get().openGroups.filter((k) => k !== key)
            : [...get().openGroups, key],
        }),

      openGroup: (key) =>
        set((state) =>
          state.openGroups.includes(key)
            ? state
            : { openGroups: [...state.openGroups, key] }
        ),
    }),
    {
      name: storageKeys.sidebar,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ collapsed: state.collapsed }),
    }
  )
);
